var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CheckCircleIcon = function (props) { return (_jsxs("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z", fill: "currentColor" }), _jsx("path", { d: "M15.8982 8L15.3473 8.59568C13.8285 10.2266 12.208 12.0783 10.691 13.7322L8.59435 11.8825L7.98977 11.3495L7 12.6402L7.59972 13.1731L10.2521 15.5141L10.803 16L11.3003 15.4618C12.9807 13.6571 14.8012 11.5468 16.4491 9.77671L17 9.18103L15.8982 8Z", fill: "white" })] }))); };
